import React from 'react';
import { useUnistyles } from 'react-native-unistyles';
import TiptapEditor from '@/components/General/inputs/QuillEditor';

const TextBlock = ({ block, isSelected, onSelect, onUpdate }) => {
    const { theme: { colors } } = useUnistyles();
    const { content, styles: blockStyles } = block;

    const handleContentChange = (html) => {
        onUpdate(block.id, { ...block.content, html });
    };

    const padding = `${blockStyles.paddingTop ?? 10}px ${blockStyles.paddingRight ?? 20}px ${blockStyles.paddingBottom ?? 10}px ${blockStyles.paddingLeft ?? 20}px`;

    if (isSelected) {
        return (
            <div
                style={{
                    padding,
                    backgroundColor: blockStyles.backgroundColor || 'transparent',
                    outline: `2px solid ${colors.primary}`,
                    outlineOffset: '-2px',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <TiptapEditor
                    value={content.html || ''}
                    onChange={handleContentChange}
                    autoFocus
                />
            </div>
        );
    }

    return (
        <div
            onClick={(e) => { e.stopPropagation(); onSelect(block.id); }}
            style={{
                padding,
                backgroundColor: blockStyles.backgroundColor || 'transparent',
                textAlign: blockStyles.textAlign || 'left',
                outline: isSelected ? `2px solid ${colors.primary}` : '2px solid transparent',
                outlineOffset: '-2px',
                cursor: 'pointer',
                minHeight: 40,
                color: '#111827',
                fontFamily: 'Arial, Helvetica, sans-serif',
                fontSize: 14,
                lineHeight: 1.6,
            }}
            dangerouslySetInnerHTML={{ __html: content.html || '<p style="color:#9ca3af;margin:0;font-family:Arial,sans-serif">Click to edit text...</p>' }}
        />
    );
};

export default TextBlock;
